import { apolloClient, AUTH_TOKEN_LOCALSTORAGE_KEY } from '../vue-apollo'
import gql from 'graphql-tag'
import CURRENT_ACCOUNT_ID from '../graphql/currentAccountId.graphql'
import CURRENT_ACCOUNT_ID_SET from '../graphql/currentAccountIdSet.graphql'

// import store from '../store'
// import gql from 'graphql-tag'
//
// export async function login () {
//   const accountId = parseJwt(token).id
//   return store.$apollo.query({
//     query: gql`
//       query ($id: String!) {
//         account(id: $id) {
//           id,
//           email,
//           isAdmin,
//           activeCartId
//         }
//       }
//     `,
//     variables: {
//       id: accountId
//     }
//   }).then(result => {
//     console.log(result)
//     commit('setCurrentUser', result.data.account)
//   })
// }

function parseJwt (token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))

  return JSON.parse(jsonPayload)
}

export function getAccountIdFromToken () {
  try {
    const token = localStorage.getItem(AUTH_TOKEN_LOCALSTORAGE_KEY)
    const accountId = parseJwt(token).id
    return accountId || null
  } catch (e) {
    return null
  }
}

export async function setCurrentAccountIdFromToken () {
  const token = localStorage.getItem(AUTH_TOKEN_LOCALSTORAGE_KEY)
  const accountId = parseJwt(token).id
  await apolloClient.mutate({
    mutation: CURRENT_ACCOUNT_ID_SET,
    variables: {
      accountId
    }
  })
}

export const getCurrentAccountId = async () => {
  const a = await apolloClient.query({
    query: CURRENT_ACCOUNT_ID
  })
  return a.data.currentAccountId
}

export const getCurrentAccount = async (input) => {
  const id = await getCurrentAccountId()
  if (!id) return null
  // const token = localStorage.getItem(AUTH_TOKEN_LOCALSTORAGE_KEY)
  // const id = parseJwt(token).id
  const response = await apolloClient.query({
    query: gql`
      query ($id: ID!) {
        account(id: $id) {
          id,
          ${input}
        }
      }
    `,
    variables: {
      id
    }
  })
  return response.data.account
}
